import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { environment } from 'src/environments/environment';
import { AdditionalRateType } from '../../models/additional-rate-type.models';
import { initialAdditionalRatesSlice } from './additional-rates.slice';
import { AdditionalRates } from '../../models/additional-rates.models';
import { MarginCoverageTypes } from 'src/app/recruiting/locums-margin-calculator/models/margin-coverage-types.models';
import { AdditionalRateTypes as AdditionalRateTypesEnum } from '../../enums/additional-rate-types';

export const AdditionalRatesStore = signalStore(
    { providedIn: 'root' },
    withState(initialAdditionalRatesSlice),
    withMethods((store) => ({
        updateAdditionalRateTypes: (additionalRateTypes: AdditionalRateType[]) => {
            patchState(store, { additionalRateTypes: additionalRateTypes });
        },
        updateMarginCoverageTypes: (marginCoverageTypes: MarginCoverageTypes[]) => {
            patchState(store, { marginCoverageTypes });
        },
        addAdditionalRate: (additionalRate: AdditionalRates) => {
            const additionalRates = [...store.additionalRates(), additionalRate];
            patchState(store, { additionalRates });
        },
        updateAdditionalRateField: (additionalRate: Partial<AdditionalRates>) => {
            const updatedAdditionalRatesList = store.additionalRates().map((rate) => {
                if (rate.additionalRateTypeId === additionalRate.additionalRateTypeId) {
                    const updatedAdditionalRates = { ...rate, ...additionalRate };
                    return getUpdatedAdditionalRates(updatedAdditionalRates);
                }
                return rate;
            });

            patchState(store, { additionalRates: updatedAdditionalRatesList });
        },
        removeAdditionalRate: (additionalRateTypeId: number) => {
            const additionalRates = store
                .additionalRates()
                .filter((rate) => rate.additionalRateTypeId !== additionalRateTypeId);
            patchState(store, { additionalRates });
        },
        getState: () => store
    })),
    environment.storeWithDevTools('locums-margin-calculator-additional-rates-store')
);

function getUpdatedAdditionalRates(additionalRate: AdditionalRates): AdditionalRates {
    const billRate = additionalRate.billRate ?? 0;
    const payRate = additionalRate.payRate ?? 0;

    if (
        additionalRate.additionalRateTypeId === Number(AdditionalRateTypesEnum.DAILY_24HOURS) ||
        additionalRate.additionalRateTypeId === Number(AdditionalRateTypesEnum.WEEKEND_CALL) ||
        additionalRate.additionalRateTypeId === Number(AdditionalRateTypesEnum.NIGHT_SHIFT_CALL)
    ) {
        const expectedShifts = additionalRate.expectedShifts ?? 0;

        return {
            ...additionalRate,
            revenue: billRate * expectedShifts,
            expense: payRate * expectedShifts
        };
    } else if (additionalRate.additionalRateTypeId === Number(AdditionalRateTypesEnum.CALL_BACK)) {
        const expectedHours = additionalRate.expectedHours ?? 0;

        return {
            ...additionalRate,
            revenue: billRate * expectedHours,
            expense: payRate * expectedHours
        };
    } else {
        return additionalRate;
    }
}
